import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatLegacyCheckboxModule as MatCheckboxModule } from '@angular/material/legacy-checkbox';
import { SharedModule } from 'app/shared/shared.module';
import { PipesModule } from 'app/shared/pipes/pipes.module';
import { FieldLayoutEditComponent } from './field-layout-edit.component';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { MatLegacyMenuModule as MatMenuModule } from '@angular/material/legacy-menu';
import { TsButtonModule } from 'tsui';

@NgModule({
  declarations: [FieldLayoutEditComponent],
  imports: [
    CommonModule,
    MatIconModule,
    MatButtonModule,
    MatCheckboxModule,
    SharedModule,
    PipesModule,
    DragDropModule,
    MatIconModule,
    MatMenuModule,
    TsButtonModule,
  ],
  exports: [FieldLayoutEditComponent],
  providers: [],
})
export class FieldLayoutEditModule {}
